import { render } from "./BannerTop.vue?vue&type=template&id=e142fcec"
import script from "./BannerTop.vue?vue&type=script&lang=js"
export * from "./BannerTop.vue?vue&type=script&lang=js"

import "./BannerTop.vue?vue&type=style&index=0&id=e142fcec&lang=scss"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__